module.exports = __webpack_public_path__ + "assets/img/heading_sm.051f8e63.webp";